export default {
  saveInfo: { id: 'save_info' },
  title: { id: 'title' },
  active: { id: 'active' },
  setupDueDate: { id: 'setup_due_date' },
  dueDate: { id: 'due_date' },
  dueDateIs: { id: 'due_date_is' },
  afterStartAt: { id: 'after_start_at' },
  days: { id: 'days' },
  position: { id: 'position' },
  sites: { id: 'sites' },
  reasonForDeletion: { id: 'reason_for_deletion' },
  needToAddDeletionReasonTooltip: { id: 'need_to_add_deletion_reason_tooltip' },
  parameters: { id: 'parameters' },
  lookupTable: { id: 'lookup_table' },
  lookupColumn: { id: 'lookup_column' },
  lookupSelect: { id: 'lookup_select' },
  textArea: { id: 'text_area' },
}
